<template>
    <v-card class="text-center">
        <v-toolbar dark color="primary" class="white--text mb-5" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title> Order View </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$store.state.invoice.dialogOrder = false"
                ><v-icon>mdi-close</v-icon></v-btn
            >
        </v-toolbar>
        <v-form ref="form" lazy-validation>
            <v-card-text class="divs">
                <v-container v-if="componentDialog" class="divs">
                    <v-row>
                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            OrderID *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['OrderID'] }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Order Status *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['OrderStatus'] }}
                            </v-chip>
                        </v-col>
                        <v-col cols="6" sm="4" lg="4" class="chps divs">
                            Customer *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Customer'] }}
                            </v-chip>
                        </v-col>

                        <v-col sm="4" lg="3" class="chps divs">
                            Terminal *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Terminal'] }}
                            </v-chip>
                        </v-col>

                        <v-col md="3" sm="4" lg="4" class="chps divs">
                            Station *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Station'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="4" lg="2" class="chps divs">
                            Shift Detail *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['ShiftDetail'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="4" lg="3" class="chps divs">
                            SplitType *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['SplitType'] }}
                            </v-chip>
                        </v-col>

                        <v-col md="3" sm="4" lg="2" class="chps divs">
                            Date *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['ShiftDate'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="2" lg="1" class="chps divs">
                            Shift *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Shift'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="2" lg="3" class="chps divs">
                            Driver *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Driver'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="2" lg="1" class="chps divs">
                            Truck *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Truck'] }}
                            </v-chip>
                        </v-col>
                        <v-col md="3" sm="2" lg="2" class="chps divs">
                            Trailer *
                            <v-chip class="divs" label value>
                                {{ orderInfo[0]['Trailer'] }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row class="divs">
                        <v-col cols="6" class="divs">
                            <v-textarea
                                v-model="orderInfo[0]['DispatchComments']"
                                class="mx-2"
                                label="Dispatch Comments"
                                rows="3"
                                prepend-icon="mdi-comment"
                                disabled
                            ></v-textarea>
                        </v-col>
                        <v-col cols="6" class="divs">
                            <v-textarea
                                v-model="orderInfo[0]['GPSComments']"
                                class="mx-2"
                                label="GPS Comments"
                                rows="3"
                                prepend-icon="mdi-comment"
                                disabled
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="divs">
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Bill of Lading"
                                v-model="orderInfo[0]['BOL']"
                                outlined
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Pickup Date"
                                placeholder="yyyy-mm-dd"
                                v-mask="'####/##/##'"
                                :rules="$store.state.dateRules"
                                type="tel"
                                :value="orderInfo[0]['DatePickup']"
                                id="orDDatePickup"
                                outlined
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Pickup Time"
                                v-model="orderInfo[0]['TimePickup']"
                                type="tel"
                                v-mask="'##:##'"
                                outlined
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Delivery Date"
                                id="orDDateDelivered"
                                :value="orderInfo[0]['DateDelivered']"
                                placeholder="yyyy-mm-dd"
                                v-mask="'####/##/##'"
                                type="tel"
                                :rules="$store.state.dateRules"
                                outlined
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <v-row justify="center" class="divs">
                    <v-col cols="1" class="divs">
                        <v-progress-circular
                            :size="70"
                            :width="7"
                            indeterminate
                            v-if="progress"
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="divs">
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Product</th>
                            <th style="text-align: center;">Quantity</th>
                            <th style="text-align: center;">Dispatched</th>
                            <th style="text-align: center;">Delivered</th>
                            <th style="text-align: center;">Temp. Adj.</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, i) in productsOrder" v-bind:key="i">
                            <td>{{ item.Product }}</td>
                            <td>{{ item.Quantity }}</td>
                            <td>
                                {{ productsOrder[i]['DispatchedQuantity'] }}
                            </td>
                            <td>{{ productsOrder[i]['DeliveredQuantity'] }}</td>
                            <td>{{ productsOrder[i]['TempAdjQuantity'] }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-form>
        <v-divider></v-divider>

        <v-card-actions v-show="!isModal">
            <v-spacer></v-spacer>
            <v-btn
                color="secondary"
                @click="$store.state.posting.dialog = false"
                >Close</v-btn
            >
            <v-btn color="secondary" @click="validate()">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'OrderData',
    directives: { mask },
    props: ['isModal'],
    data: function() {
        return {
            headerProducts: [
                { text: 'Product', width: '2' },
                { text: 'Requested', width: '1' },
                { text: 'Dispatched', width: '1' },
                { text: 'Delivered', width: '1' },
                { text: 'Temp. Adj.', width: '1' }
            ],
            orderInfo: [],
            productsOrder: [],
            componentDialog: false,
            progress: false
        };
    },
    mounted() {
        this.loadOrderInfo(this.$store.state.orderInfo.orderId);
        this.loadProductsOrder(this.$store.state.orderInfo.orderId);
    },
    methods: {
        loadOrderInfo: function(orderID) {
            this.$store.state.isLoading = true;
            this.progress = true;
            axios
                .get('order/info/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orderInfo = response.data.data;
                    console.log(this.orderInfo);
                    this.componentDialog = true;
                    this.progress = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadProductsOrder: function(orderID) {
            axios
                .get('order-detail/order/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.productsOrder = response.data.data;
                    console.log(this.productsOrder);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        saveOrderData: function() {
            this.$store.state.isLoading = true;

            var params = {
                BillOfLading: this.orderInfo[0]['BOL'],
                DateTerminalPick: this.getMsk('orDDatePickup'),
                TimeTerminalPick: this.orderInfo[0]['TimePickup'],
                DateDelivered: this.getMsk('orDDateDelivered'),
                TimeDelivered: this.orderInfo[0]['TimeDelivered']
            };
            axios
                .put('order/' + this.$store.state.orderInfo.orderId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.$store.state.transacting.watch = true;
                    console.log(response);
                    for (const i in this.productsOrder) {
                        var orderDetailID = this.productsOrder[i].id;
                        var params = {
                            DeliveredQuantity: this.productsOrder[i][
                                'DeliveredQuantity'
                            ],
                            TempAdjQuantity: this.productsOrder[i][
                                'TempAdjQuantity'
                            ],
                            Temperature: this.productsOrder[i]['Temperature'],
                            Density: this.productsOrder[i]['Density']
                        };
                        var str = this.$store;
                        axios
                            .put('order-detail/' + orderDetailID, params, {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            })
                            .then(response => {
                                console.log(response);
                                this.$store.state.posting.dialog = false;
                                this.$store.dispatch('setSnackbar', {
                                    color: 'success',
                                    text: 'Order saved successfully'
                                });
                            })
                            .catch(function(error) {
                                console.log(error);
                                if (error.response.status === 403) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'You do not have the permission to use this function.'
                                    });
                                }
                                if (error.response.status === 500) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'An error has ocurred, please try again.'
                                    });
                                }
                            });
                    }
                })
                .catch(function(error) {
                    console.log(error);

                    this.$store.state.transacting.watch = false;
                });
            this.$store.state.isLoading = false;
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.saveOrderData();
            }
        },
        cancel: function() {
            console.log('cancel');
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        }
    }
};
</script>
<style>
div.chps {
    float: left;
}

.chps > span {
    width: 100%;
}
div.divs {
    margin-top: 10px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
